import React from "react"
import PropTypes from "prop-types"
import { Rating, LinearProgress } from "@mui/material"
import { plural } from "./datetime"

/**
 * Course rating at a glance: the average, the star row, the number of
 * reviews and one bar per star value (5 down to 1), Udemy style.
 *
 * Stacks on phones; the bars sit beside the average from `sm` up.
 */
export default function RatingSummary({ average, count, distribution }) {
    const total = count || 0

    return (
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-8">
            <div className="flex items-center gap-3 sm:flex-col sm:items-center sm:gap-1">
                <span className="text-4xl font-bold text-amber-600">
                    {average !== null && average !== undefined
                        ? Number(average).toFixed(1)
                        : "–"}
                </span>
                <div className="flex flex-col sm:items-center">
                    <Rating
                        value={Number(average) || 0}
                        precision={0.1}
                        size="small"
                        readOnly
                    />
                    <span className="text-xs text-slate-500">
                        {plural(total, "rating")}
                    </span>
                </div>
            </div>

            <div className="flex-1 space-y-1.5">
                {[5, 4, 3, 2, 1].map((star) => {
                    const value = Number(distribution?.[String(star)]) || 0
                    const percent = total ? Math.round((value / total) * 100) : 0
                    return (
                        <div
                            key={star}
                            className="flex items-center gap-2 text-xs text-slate-500"
                        >
                            <span className="w-10 shrink-0">{star} star</span>
                            <LinearProgress
                                variant="determinate"
                                value={percent}
                                sx={{
                                    flex: 1,
                                    height: 8,
                                    borderRadius: 4,
                                    bgcolor: "#f1f5f9",
                                    "& .MuiLinearProgress-bar": {
                                        bgcolor: "#f59e0b",
                                        borderRadius: 4
                                    }
                                }}
                            />
                            <span className="w-9 shrink-0 text-right">
                                {percent}%
                            </span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

RatingSummary.propTypes = {
    average: PropTypes.number,
    count: PropTypes.number,
    distribution: PropTypes.object
}
